import React from "react"
import "../styles/globals.css"
import type { AppProps } from "next/app"
import { ErrorBoundary } from "../components/ErrorBoundary"
import "core-js/stable"
import "regenerator-runtime/runtime"

export default function App({ Component, pageProps }: AppProps) {
  return (
    <ErrorBoundary>
      <Component {...pageProps} />
    </ErrorBoundary>
  )
}
